import outline from './outline.json'

export interface OutlineBox {
  left: number
  top: number
  width: number
  height: number
}

interface TitleOutlineProps {
  /** Where each letter stands, in CSS pixels: the boxes the 3D letters will take. */
  boxes: OutlineBox[]
  className?: string
}

/**
 * The title's letters as flat silhouettes, cut from the very model the 3D title is made of, so
 * what shows while the scene loads (and what stays when it cannot run) is the same shape to
 * the pixel. Purely visual: the hidden DOM title keeps the heading and the layout.
 */
export const TitleOutline: React.FC<TitleOutlineProps> = ({ boxes, className = '' }) => {
  if (boxes.length !== outline.letters.length) return null
  return (
    <svg
      aria-hidden="true"
      className={`pointer-events-none fixed inset-0 h-full w-full ${className}`}
      style={{ color: '#fff' }}
    >
      {outline.letters.map((letter, i) => {
        const box = boxes[i]
        return (
          <g
            key={i}
            transform={`translate(${box.left + box.width / 2} ${box.top}) scale(${box.width / letter.width} ${box.height})`}
          >
            {letter.paths.map((ring, k) => (
              <polygon
                key={k}
                points={ring.join(' ')}
                fill="currentColor"
                stroke="currentColor"
                strokeWidth={0.75}
                vectorEffect="non-scaling-stroke"
                strokeLinejoin="round"
              />
            ))}
          </g>
        )
      })}
    </svg>
  )
}
